export default {
  title: '关于6080影视',
  brandTitle: '品牌介绍',
  brandContent1: '6080影视创立于2018年，是国内领先的免费高清电影在线观看平台。我们依托6080新视觉影视强大的资源库，致力于为广大影迷提供最优质的在线观影体验。',
  brandContent2: '平台汇聚了海量电影资源，涵盖动作、喜剧、科幻、爱情、恐怖、动画、剧情、战争、纪录片等多种类型，满足不同用户的观影需求。从经典老片到最新大片，一应俱全。',
  brandContent3: '我们拥有专业的视频技术团队和内容运营团队，确保每一部影片都能以最高画质、最流畅的方式呈现给用户。始终坚持以用户体验为核心，不断优化产品和服务。',
  reputationTitle: '用户口碑',
  contactTitle: '联系我们',
  contactEmail: '电子邮箱',
  contactWechat: '微信公众号',
  contactQQ: 'QQ群',
  contactAddress: '公司地址',
  address: '北京市朝阳区光华路SOHO 2期',
  reputation1Name: '影迷小王',
  reputation1Text: '6080影视真的太棒了！资源更新很快，画质也很清晰，完全不卡顿。自从发现了这个网站，我再也不用到处找资源了。',
  reputation2Name: '电影爱好者阿明',
  reputation2Text: '用了快两年了，体验一直很好。分类清晰，找片方便，最重要的是完全免费，强烈推荐给所有影迷朋友！',
  reputation3Name: '追剧达人Lucy',
  reputation3Text: '片库真的太全了，很多冷门经典老片都能找到。播放流畅度也很好，4K画质看着特别过瘾。每天都会来看看更新了什么新片。',
  stats1: '50000+',
  stats1Label: '电影资源',
  stats2: '1000万+',
  stats2Label: '月活用户',
  stats3: '99.9%',
  stats3Label: '播放成功率',
  stats4: '8年',
  stats4Label: '稳定运营',
};